import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';

const AddButton = React.memo(({ title, ...other }) => {
    return (
        <Tooltip title={title}>
            <div>
                <Fab color="primary" size="medium" {...other}>
                    <AddIcon />
                </Fab>
            </div>
        </Tooltip>
    )
});

export default AddButton;

